import moment from 'moment';

export const exceptionName = (value) => (value || 'Unknown exception').split('\\').pop();
export const fileName = (value) => value ? value.split(/[\\/]/).pop() : 'Source not recorded';
export const reportDate = (value, format = 'D MMM YYYY, HH:mm') => value && moment(value).isValid() ? moment(value).format(format) : 'Time not recorded';

export function reportedUser(value) {
    const text = value || 'Unknown user';
    const match = /^(.+?)\s*-\s*\((.+)\)$/.exec(text);
    return { name: match?.[1] || text, email: match?.[2] || '' };
}

export function traceFrames(value) {
    if (Array.isArray(value)) return value.filter((frame) => frame && typeof frame === 'object');
    if (typeof value === 'string') {
        try { return traceFrames(JSON.parse(value)); } catch { return []; }
    }
    return [];
}
